module.exports = __webpack_public_path__ + "static/media/commercial-vehicle-details-mobile.d249045f.png";